// extracted by mini-css-extract-plugin
export default {"wrapper":"bottomNav_wrapper__9Yi0H","nav":"bottomNav_nav__xic2y"};